module.exports = __webpack_public_path__ + "static/media/495b37d5-b5be-4fdb-a58a-21c035cdada8.811be84a.JPG";